import { useNavigate } from 'react-router-dom';
import { ArrowRight } from '../icons';
import { Button } from '../ui/button';

export function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 bg-brand-40">
      <div className="max-w-[1216px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 relative hidden lg:block">
            <div className="relative max-w-sm mx-auto">
              <div className="absolute inset-0 bg-brand-60/30 rounded-[32px] transform -rotate-3" />
              <div className="relative bg-white rounded-[32px] shadow-soft-lg p-6">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-success-10 rounded-full flex items-center justify-center">
                    <span className="text-2xl">🎯</span>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-80">
                      Your Growth Journey
                    </p>
                    <p className="text-sm text-gray-40">
                      Personalized for you
                    </p>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 p-3 bg-success-5 rounded-xl">
                    <div className="w-8 h-8 bg-success-40 rounded-full flex items-center justify-center text-white text-sm font-bold">
                      1
                    </div>
                    <span className="text-sm text-gray-60">
                      Complete Assessment
                    </span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-gray-10 rounded-xl">
                    <div className="w-8 h-8 bg-gray-30 rounded-full flex items-center justify-center text-gray-60 text-sm font-bold">
                      2
                    </div>
                    <span className="text-sm text-gray-40">
                      Get AI Insights
                    </span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-gray-10 rounded-xl">
                    <div className="w-8 h-8 bg-gray-30 rounded-full flex items-center justify-center text-gray-60 text-sm font-bold">
                      3
                    </div>
                    <span className="text-sm text-gray-40">
                      Connect with Coach
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-3xl md:text-heading-md font-bold text-white mb-4">
              Take Care of Your Growth — Start Today
            </h2>
            <p className="text-paragraph-xl text-brand-10 mb-8 max-w-xl mx-auto lg:mx-0">
              Don't wait to take the first step. Your journey to self-discovery
              starts with a simple, science-backed assessment available now —
              anytime, any device.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="secondary"
                size="lg"
                onClick={() => navigate('/register')}
                className="gap-2 bg-white text-brand-90 hover:bg-gray-10"
              >
                Get Started Now
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate('/coach-registration')}
                className="border-white text-white hover:bg-white/10"
              >
                Become a Coach
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
